import { TYPE_STRING } from './input-types';

export const id = 'customField3';
export const apiKey = 'CustomField3';
export const type = TYPE_STRING;

export const customField3 = {
  id,
  apiKey,
  type,
};
